import React from 'react';
import { SelectContainer, FilterSelect, SelectIcon } from './FilterBar.styled';

const CategorySelect = ({ categories, activeCategory, onSelect }) => {
    return (
        <SelectContainer>
            <FilterSelect
                value={activeCategory || ''}
                onChange={(e) => onSelect(e.target.value || null)}
                aria-label="Filtrar por categoría"
            >
                <option value="">Todas las categorías</option>
                {categories.map(category => (
                    <option key={category.id} value={category.id}>
                        {category.namePlural}
                    </option>
                ))}
            </FilterSelect>
            <SelectIcon>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="m6 9 6 6 6-6" />
                </svg>
            </SelectIcon>
        </SelectContainer>
    );
};

export default CategorySelect;
